module.exports = __webpack_public_path__ + "img/isle-of-man.be38d2c7.svg";